module.exports = __webpack_public_path__ + "static/media/slide9.ef6383d8.jpg";